export default __webpack_public_path__ + "static/media/roles_10.05ee11ee.png";